<template>
    <div class="headCon">
        <div>
            <div class="logo"></div>
            <ul class="nav">
                <li v-for="(item, index) in navList" :key="index" :class="actPath == item.path ? 'act' : ''" @click="goPage(item.path)">
                    <div></div>
                    <p>{{ item.name }}</p>
                </li>
            </ul>
            <div class="searchBox">
                <input type="text" placeholder="搜索..." v-model="searchVal" @click.stop="searchInputFocus">
                <div @click="goSearch" class="searchBtn"></div>
            </div>
            <div class="isLoginBox">
                <div class="login_btn" v-if="!online" @click="showLoginBox">登录</div>
                <div class="login_btn" v-else @click="goMyHistory">{{nickName}}</div>
                <!-- <img :src="avatar" alt="" v-else class="loginCover" @click="goMyHistory"> -->
            </div>
            <div class="statistics" v-show="statistics" @click="goStatisticsList">数据统计</div>
        </div>
    </div>
</template>

<script>

export default {
    data() {
        return {
            navList: [
                {
                    "name": "首页",
                    "path": "/"
                },
                {
                    "name": "分类",
                    "path": "/classBook"
                },
            ],
            actPath: "/",
            searchVal: "",
            nickName: "云图",
            isSearchInputFocus: false,
            statistics: false,
        }
    },
    props: {
        dialogHide: Boolean,
    },
    computed: {
        routePath() {
            return this.$route.path;
        },
        online() {
            return this.$store.state.online;
        },
        deptName () {
            return localStorage.getItem("deptName");
        },
        admin() {
            return this.$store.state.admin;
        }
    },
    mounted() {
        let that = this;
        that.actPath = that.routePath;
        if( that.online ) {
            that.nickName = sessionStorage.getItem("nickName");
        }
        if( that.actPath != "/search" ) {
            that.searchVal = '';
        }else{
            that.searchVal = !sessionStorage.getItem("searchVal") ? "" : sessionStorage.getItem("searchVal");
        }
        console.log(that.admin)
        if( that.admin ) {
            that.statistics = true;
        }
    },
    methods: {
        goPage(path) {
            let that = this;
            that.actPath = path;
            that.$router.push(path);
        },
        goSearch() {
            let that = this;
            that.$store.commit("setSearchVal", that.searchVal)
            sessionStorage.setItem("searchVal", that.searchVal);

            if( that.routePath != "/search" ) {
                that.$router.push("/search");
            }
        },
        searchInputFocus() {
            let that = this;
            that.isSearchInputFocus = true;
            that.$emit("dialogShow");
        },
        changeSearchVal(name){
            let that = this;
            that.searchVal = name;
            that.goSearch();
        },
        goMyHistory() {
            let that = this;
            that.$router.push("/my/listenHistory");
        },
        routerReload() {
            let that = this;
            that.$store.commit("setIsRouterAlive", false);
            that.$nextTick(()=>{
                that.$store.commit("setIsRouterAlive", true);
            })
        },
        goIndex() {
            let that = this;
            that.$store.commit("setIsRouterAlive", false);
            that.$nextTick(()=>{
                that.$store.commit("setIsRouterAlive", true);
            })
        },
        showLoginBox() {
            let that = this;
            // that.$store.commit("setIsShowLoginBox", true);
            that.$router.push("/login");
        },
        goStatisticsList() {
            let that = this;
            that.$router.push("/statistics");
        }
    },
    watch: {
        routePath(newV) {
            let that = this;
            that.actPath = newV;
            if( newV != "/search" ) {
                that.searchVal = '';
            }else{
                that.searchVal = !sessionStorage.getItem("searchVal") ? "" : sessionStorage.getItem("searchVal");
            }
        },
        versionList(newV) {
            let that = this;
            for( let i=0; i<newV.length; i++ ) {
                if( localStorage.getItem("version") == newV[i].code ) {
                    // that.selectedVersion = newV[i];
                    that.$store.commit("setHeadSelectedVersion", newV[i]);
                }
            }
        },
        dialogHide(newV) {
            console.log(newV)
            let that = this;
            if( newV ) {
                that.isSearchInputFocus = false;
            }
        },
        online(newV) {
            let that = this;
            if( newV ) {
                that.nickName = sessionStorage.getItem("nickName");
            }
        },
        admin(newV) {
            let that = this;
            that.statistics = newV;
        }
    }
}
</script>

<style lang="scss" scoped>
    .headCon{
        width: 100%;
        box-shadow: 0px 2px 12px 1px rgba(228,228,228,0.85);
        height: 70px;
        margin-bottom: 30px;
        >div{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            >.logo{
                width: 111px;
                height: 32px;
                // margin-right: 76px;
                background-image: url('../assets/imgs/commin/logo.png');
                background-position: center;
                background-repeat: no-repeat;
            }
            >.nav{
                overflow: hidden;
                >li{
                    float: left;
                    height: 70px;
                    position: relative;
                    margin-right: 50px;
                    cursor: pointer;
                    >div{
                        width: 36px;
                        height: 7px;
                        border-radius: 4px;
                        background: #fff;
                        position: absolute;
                        left: 50%;
                        bottom: 0;
                        margin-left: -18px;
                    }
                    >p{
                        font-size: 20px;
                        @include secondary_color(#999);
                        line-height: 70px;
                    }
                    &.act{
                        >div{
                            background: #1AA7E0;
                        }
                        >p{
                            font-size: 22px;
                            @include dominant_color(#1c1c1c);
                        }
                    }
                    &:last-child{
                        margin-right: 0;
                    }
                }
            }
            >.searchBox{
                width: 273px;
                height: 40px;
                display: flex;
                position: relative;
                z-index: 2;
                >input{
                    border: 1px solid #1AA7E0;
                    border-right: 0;
                    border-top-left-radius: 48px;
                    border-bottom-left-radius: 48px;
                    padding: 0 20px;
                    width: 193px;
                    outline: none;
                    font-size: 18px;
                    line-height: 38px;
                    @include secondary_color(#999);
                }
                >.searchBtn{
                    width: 80px;
                    height: 40px;
                    background-image: url('../assets/imgs/commin/search_btn.png');
                    background-position: center;
                    background-repeat: no-repeat;
                    background-size: 100% 100%;
                    cursor: pointer;
                }
            }
            >.isLoginBox{
                overflow: hidden;
                >.login_btn{
                    // margin: 0 22px 0 100px;
                    font-size: 22px;
                    @include secondary_color(#999);
                    cursor: pointer;
                }
                >img{
                    display: block;
                    border-radius: 70px;
                    width: 55px;
                    height: 55px;
                    // margin: 0 44px 0 60px;
                    // display: none;
                    // background: #000;
                    cursor: pointer;
                }
            }
            >.statistics{
                font-size: 18px;
                background: #1AA7E0;
                color: #fff;
                text-align: center;
                width: 150px;
                height: 40px;
                line-height: 40px;
                border-radius: 40px;
                cursor: pointer;
            }
        }
        
    }
</style>
